import * as React  from 'react';
import RecommendedProducts from '.';
import RecommendedVariantsQuery from '../Query/Products/RecommendedProducts';

interface IRecommendedProductsProps {
    productId: string;
    country?: string;
    GTMItemListName?: string;
}

export class SepararelyLoadedRecommendedProducts extends React.Component<IRecommendedProductsProps> {
    render() {
        if (!this.props.productId) {
            return null;
        }

        return (
            <RecommendedVariantsQuery productId={this.props.productId} country={this.props.country}>
            {({ recommendedVariants }: any) => {
                if (recommendedVariants.loading || recommendedVariants.error) {
                    return null;
                }

                if (!Array.isArray(recommendedVariants.recommendedProducts)) {
                    return null;
                }

                return <RecommendedProducts variants={recommendedVariants.recommendedProducts.map((p: any) => p.productVariant)} GTMItemListName={this.props.GTMItemListName} />;
            }

            }
            </RecommendedVariantsQuery>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RecommendedProducts/SeparatelyLoadedRecommendedProducts.tsx